export default {
    data() {
        return {
            modalImage: false,
            modalImageUrl: null,
            modalImageContainer: false,
        }
    },
    methods: {
        enlargeImage(event) {
            this.modalImage = true;
            this.modalImageContainer = false;

            let imageUrl = event.srcElement.src;
            if(event.srcElement.dataset.srcLarge) {
                imageUrl = event.srcElement.dataset.srcLarge;
            }
            if(event.srcElement.dataset.imgContainer) {
                this.modalImageContainer = true;
            }

            this.modalImageUrl = imageUrl;
        },
        formatBullets(bullets) {
			bullets = bullets.replace(/<p>/ig, "");
			bullets = bullets.split("</p>");
			bullets = bullets.map(bullet => bullet.trim());
			bullets = bullets.filter((bullet) => {
                let strippedString = bullet.replace(/(<([^>]+)>)/gi, "");
                strippedString = strippedString.trim();

                return strippedString.length > 0;
            });

            return bullets;
        },
    },
}